import { TourSearchDestination } from 'shared/api/tours/search'
import KgFlag from 'shared/icons/flags/kg_flag.webp'
import KzFlag from 'shared/icons/flags/kz_flag.svg'

export const AgesTour = {
  adults: {
    minCount: 1,
    maxCount: 4,
    name: 'adults',
    defaultValue: 2,
    rangeDescription: 'tours_block.adults_range_age',
    key: 'adults',
  },
  children: {
    minCount: 0,
    maxCount: 3,
    name: 'children',
    defaultValue: 0,
    rangeDescription: 'tours_block.children_range_age',
    key: 'children',
  },
} as const

export type AgesTourType = keyof typeof AgesTour

export const AgesTourList = Object.keys(AgesTour)?.map((key) => ({
  ...AgesTour[key as keyof typeof AgesTour],
  key: key,
}))

export const AgesDefaultValues = {
  adults: AgesTour.adults.minCount,
  children: AgesTour.children.minCount,
}

export const minAgesChild = 0

export const maxAgesChild = 17

export const toursDepartureOptions: TourSearchDestination[] = [
  {
    state_id: 2000003268,
    name: 'Бишкек',
    flag: KgFlag,
  },
  {
    state_id: 798,
    name: 'Алматы',
    flag: KzFlag,
  },
]

export const guideTooltipDelay = 1000
